import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubCategories } from '../store/slices/subCategorySlice';
import { fetchCategories } from '../store/slices/categorySlice';
import Header from '../components/layout/Header';
import { motion } from 'framer-motion';
import { FiArrowLeft } from 'react-icons/fi';
import CategoryCard from '../components/common/CategoryCard';
import '../styles/MainCategorySelection.css';

const SubCategorySelection: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { categories, loading: categoriesLoading } = useSelector((state: any) => state.category);
    const { subCategories, loading: subCategoriesLoading } = useSelector((state: any) => state.subCategory);

    useEffect(() => {
        if (id) {
            dispatch(fetchSubCategories({ filter: { "category": { "_id": id } } }) as any);
        }
        if (categories.length === 0) {
            dispatch(fetchCategories() as any);
        }
        window.scrollTo(0, 0);
    }, [id, dispatch, categories.length]);

    const currentSubCategories = subCategories || [];
    const currentCategory = categories.find((c: any) => c._id === id);

    const handleSubCategoryClick = (subCategoryId: string) => {
        navigate(`/products?subcategory=${subCategoryId}`);
    };

    return (
        <>
            <Header />
            <div className="category-selection-wrapper">
                <motion.div
                    className="category-selection-header"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <div className="category-selection-header-title-container">
                        <button className="category-back-button" onClick={() => navigate(-1)} aria-label="Go Back">
                            <FiArrowLeft />
                        </button>
                        <h1 className="category-selection-title">
                            {currentCategory?.name || 'Explore Sub-Categories'}
                        </h1>
                    </div>
                    <p className="category-selection-subtitle">
                        Discover the best in {currentCategory?.name?.toLowerCase() || 'this section'}
                    </p>
                </motion.div>

                <div className="category-grid">
                    {subCategoriesLoading ? (
                        Array(6).fill(0).map((_, i) => (
                            <div key={i} className="category-skeleton" />
                        ))
                    ) : (
                        currentSubCategories.map((sub: any, index: number) => (
                            <CategoryCard
                                key={sub._id}
                                id={sub._id}
                                name={sub.name}
                                description={sub.description}
                                image={sub.image || ''}
                                index={index}
                                onClick={handleSubCategoryClick}
                            />
                        ))
                    )}
                </div>

                {!subCategoriesLoading && currentSubCategories.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '100px 0' }}>
                        <h2 style={{ color: '#64748b' }}>No sub-categories found here.</h2>
                        <button
                            onClick={() => navigate(-1)}
                            style={{
                                marginTop: '20px',
                                padding: '12px 30px',
                                backgroundColor: '#2874f0',
                                color: '#fff',
                                borderRadius: '12px',
                                border: 'none',
                                fontWeight: '700',
                                cursor: 'pointer'
                            }}
                        >
                            Go Back
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default SubCategorySelection;
